$(function(){
    if($("#application_event_accept_formalities").length) {
        $(".radio").click(check_application_formalities_accepted);
        check_application_formalities_accepted()
    }
});
function check_application_formalities_accepted() {
    if ($("#application_event_accept_formalities")[0].checked == true) {
        $("div.application_contact").show()
        $("div.application_case_id").show()
    } else {
        $("div.application_contact").hide()
        $("div.application_case_id").hide()
    }
    if ($("#application_event_reject_formalities")[0].checked == true) {
        $("div.application_comment").show()
    } else {
        $("div.application_comment").hide()
    }
}